"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Report = void 0;
var axios_1 = require("axios");
var types_1 = require("./types");
var proto_1 = require("../proto");
var Report = /** @class */ (function () {
    function Report(params) {
        this.reportNoLimit = false;
        this.reported = false;
        this.events = new proto_1.mmsevent.EventList();
        this._country = params.country;
        this._env = params.env || types_1.IEnv.STAGING; // set default env to staging
        this._biz = params.biz;
        this._sdkVersion = params.sdkVersion;
        this._domain = types_1.ICountryDomain[params.country];
        this._serviceIndex = params.serviceIndex;
        this._serviceId = params.serviceId;
        this._vid = params.vid;
        this._uid = params.uid;
        this.reportNoLimit = params.reportNoLimit;
    }
    Report.prototype.genHeader = function (eventId) {
        return proto_1.mmsevent.Header.create({
            id: eventId,
            uid: this._uid,
            biz: this._biz,
            sceneId: 109,
            country: this._country,
            os: 2,
            ua: window.navigator.userAgent,
            sdkVersion: this._sdkVersion,
            timestamp: Date.now()
        });
    };
    Report.prototype.FileTransferEvent = function (params) {
        var _a, _b, _c;
        var originBody = __assign(__assign({}, params), { serviceId: (_a = this._serviceId) !== null && _a !== void 0 ? _a : params.serviceId, serviceIndex: (_b = this._serviceIndex) !== null && _b !== void 0 ? _b : params.serviceIndex, vid: (_c = this._vid) !== null && _c !== void 0 ? _c : params.vid });
        var body = proto_1.mmsevent.FileTransferEvent.create(originBody);
        proto_1.mmsevent.FileTransferEvent.verify(body);
        var ev = proto_1.mmsevent.Event.create({
            header: this.genHeader(proto_1.mmsevent.EventID.MMSFileTransferEvent),
            body: proto_1.mmsevent.FileTransferEvent.encode(body).finish()
        });
        this.events.events.push(ev);
        return this;
    };
    // ImgGetStrategyEvent(params: {
    //   actionId: number
    //   ver?: number
    //   cost?: number
    //   retryCount?: number
    //   latitude?: number
    //   longitude?: number
    // }) {
    //   const body = mmsevent.ImgGetStrategyEvent.create(params)
    //   mmsevent.ImgGetStrategyEvent.verify(body)
    //   const ev = mmsevent.Event.create({
    //     header: this.genHeader(mmsevent.EventID.MMSImgGetStrategyEvent),
    //     body: mmsevent.ImgGetStrategyEvent.encode(body).finish()
    //   })
    //   this.events.events.push(ev)
    //   return this
    // }
    // GetEndpointCfgEvent(params: {
    //   actionId: number
    //   ver?: number
    //   cost?: number
    //   retryCount?: number
    //   latitude?: number
    //   longitude?: number
    //   triggerScene?: number
    // }) {
    //   const body = mmsevent.GetEndpointCfgEvent.create(params)
    //   mmsevent.GetEndpointCfgEvent.verify(body)
    //   const ev = mmsevent.Event.create({
    //     header: this.genHeader(mmsevent.EventID.MMSGetEndpointCfgEvent),
    //     body: mmsevent.GetEndpointCfgEvent.encode(body).finish()
    //   })
    //   this.events.events.push(ev)
    //   return this
    // }
    Report.prototype.ImgPreuploadEvent = function (params) {
        var body = proto_1.mmsevent.ImgPreuploadEvent.create(params);
        proto_1.mmsevent.ImgPreuploadEvent.verify(body);
        var ev = proto_1.mmsevent.Event.create({
            header: this.genHeader(proto_1.mmsevent.EventID.MMSImgPreuploadEvent),
            body: proto_1.mmsevent.ImgPreuploadEvent.encode(body).finish()
        });
        this.events.events.push(ev);
        return this;
    };
    Report.prototype.ImgFileTransferEvent = function (params) {
        var body = proto_1.mmsevent.ImgFileTransferEvent.create(params);
        proto_1.mmsevent.ImgFileTransferEvent.verify(body);
        var ev = proto_1.mmsevent.Event.create({
            header: this.genHeader(proto_1.mmsevent.EventID.MMSImgFileTransferEvent),
            body: proto_1.mmsevent.ImgFileTransferEvent.encode(body).finish()
        });
        this.events.events.push(ev);
        return this;
    };
    Report.prototype.ImgNotifyEvent = function (params) {
        var body = proto_1.mmsevent.ImgNotifyEvent.create(params);
        proto_1.mmsevent.ImgNotifyEvent.verify(body);
        var ev = proto_1.mmsevent.Event.create({
            header: this.genHeader(proto_1.mmsevent.EventID.MMSImgNotifyEvent),
            body: proto_1.mmsevent.ImgNotifyEvent.encode(body).finish()
        });
        this.events.events.push(ev);
        return this;
    };
    Report.prototype.report = function () {
        if (this.reported && !this.reportNoLimit)
            return;
        else
            this.reported = true;
        var url = "https://data-rep.livetech.".concat(types_1.IEnvDomain[this._env], "shopee.").concat(this._domain, "/dataapi/dataweb/event/reportPB");
        proto_1.mmsevent.EventList.verify(this.events);
        var data = proto_1.mmsevent.EventList.encode(this.events).finish();
        this.events.events.length = 0;
        return axios_1.default.post(url, data.slice(), {
            headers: {
                'Content-Type': 'application/octet-stream'
            }
        });
    };
    return Report;
}());
exports.Report = Report;
